<template>
    <sa-page-layout :btnNewVisible="btnNewVisible" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :linkedit="linkedit" :showModalLoading="showModalLoading">
        <template slot="table-body">
            <data-analysis-tables-list-component ref="DataAnalysisTablesListComponent" @afterLoadData="onAfterLoadData"></data-analysis-tables-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import DataAnalysisTablesListComponent from "../components/DataAnalysisTablesListComponent.vue";
export default {
    components: { SaPageLayout, DataAnalysisTablesListComponent },
    data() {
        return {
            btnNewVisible: true,
            pathResource: "",
            linkedit: "/dataanalysistables",
            showModalLoading: false,
            listKey: 0,
        };
    },
    mounted() {
        let me = this;
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            me.$refs.DataAnalysisTablesListComponent.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
    },
};
</script>

<style></style>
